var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-edit" },
    [
      _c(
        "actionBarComponent",
        {
          attrs: {
            title: _vm.$t("__.Crud.pcp.manipulacaoOrdem.pcpEdit"),
            showSave: _vm.model.manipulacaoOrdemId && _vm.model.dataFim == null,
          },
          on: {
            onSave: function ($event) {
              _vm.save().withLoading()
            },
          },
          scopedSlots: _vm._u([
            {
              key: "buttonSlot0",
              fn: function (ref) {
                var open = ref.open
                return _c(
                  "div",
                  {
                    attrs: {
                      title: _vm.$t(
                        "__.Components.parent.statusPCP.view_vue_html.pcpRapido"
                      ),
                    },
                    on: {
                      click: function ($event) {
                        _vm.onShowEtapasPcp(open)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-list",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                )
              },
            },
          ]),
        },
        [
          _c(
            "div",
            { attrs: { slot: "modalSlot0" }, slot: "modalSlot0" },
            [_c("pcpRapidoComponent")],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { novalidate: "novalidate" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              _vm.save().withLoading()
            },
          },
        },
        [
          _c(
            "fieldset-component",
            {
              attrs: {
                title: _vm.$t(
                  "__.Crud.pcp.manipulacaoOrdem.manipulacaoOrdemPCP"
                ),
                collapsed: false,
              },
            },
            [
              _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-8" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.errors.first("manipulacaoOrdemCodigo"),
                            expression:
                              "errors.first('manipulacaoOrdemCodigo')",
                          },
                        ],
                        staticClass: "form-group",
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: {
                              for: "manipulacaoOrdemCodigo",
                              title: _vm.$t("__.obrigatorio"),
                            },
                          },
                          [
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("*"),
                            ]),
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.pcp.manipulacaoOrdem.manipulacaoOrdemCodigo"
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            { name: "focus", rawName: "v-focus" },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.manipulacaoOrdemCodigo,
                              expression: "manipulacaoOrdemCodigo",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            autocomplete: "off",
                            type: "text",
                            id: "manipulacaoOrdemCodigo",
                            name: "manipulacaoOrdemCodigo",
                          },
                          domProps: { value: _vm.manipulacaoOrdemCodigo },
                          on: {
                            keydown: function ($event) {
                              if (
                                !("button" in $event) &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              _vm.onChangeManipulacaoOrdemCodigo().withLoading()
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.manipulacaoOrdemCodigo = $event.target.value
                            },
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-4" }, [
                    _c(
                      "button",
                      {
                        staticClass: "ajuste-button-form",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.onChangeManipulacaoOrdemCodigo().withLoading()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-search",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("__.Crud.pcp.pesquisar")) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "ajuste-button-form",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.onShowDadosNotaEntradaLote()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-search-plus",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.pcp.manipulacaoOrdem.pesquisaAvancada"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "ativo" },
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t(
                                  "__.Crud.pcp.manipulacaoOrdem.manipulacao"
                                )
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.ativoDescricao,
                            expression: "ativoDescricao",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          autocomplete: "off",
                          type: "text",
                          id: "ativo",
                          name: "ativo",
                          disabled: "",
                        },
                        domProps: { value: _vm.ativoDescricao },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.ativoDescricao = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-2" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "paciente" },
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t("__.Crud.pcp.manipulacaoOrdem.paciente")
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.manipulacaoOrdem.pacienteNome,
                            expression: "model.manipulacaoOrdem.pacienteNome",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          autocomplete: "off",
                          type: "text",
                          id: "paciente",
                          name: "paciente",
                          disabled: "",
                        },
                        domProps: {
                          value: _vm.model.manipulacaoOrdem.pacienteNome,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.model.manipulacaoOrdem,
                              "pacienteNome",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-3" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "paciente" },
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t("__.Crud.pcp.manipulacaoOrdem.cliente")
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.manipulacaoOrdem.clienteNome,
                            expression: "model.manipulacaoOrdem.clienteNome",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          autocomplete: "off",
                          type: "text",
                          id: "clienteNome",
                          name: "clienteNome",
                          disabled: "",
                        },
                        domProps: {
                          value: _vm.model.manipulacaoOrdem.clienteNome,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.model.manipulacaoOrdem,
                              "clienteNome",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-1" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "venda" },
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t(
                                  "__.Crud.pcp.manipulacaoOrdem.codigoVenda"
                                )
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.manipulacaoOrdem.codigoVenda,
                            expression: "model.manipulacaoOrdem.codigoVenda",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          autocomplete: "off",
                          type: "text",
                          id: "venda",
                          name: "venda",
                          disabled: "",
                        },
                        domProps: {
                          value: _vm.model.manipulacaoOrdem.codigoVenda,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.model.manipulacaoOrdem,
                              "codigoVenda",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("etapasComponent", {
            ref: "etapasComponent",
            attrs: {
              dataInicioProp: _vm.model.dataInicio,
              dataFimProp: _vm.model.dataFim,
              destinoManipulacaoProp: _vm.destinoManipulacao,
            },
          }),
          _vm._v(" "),
          _c("fieldset", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12 newbtn" }, [
                _c("div", { staticClass: "form-group" }, [
                  _vm.model.manipulacaoOrdemId && _vm.model.dataFim == null
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          attrs: { type: "submit" },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-save",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("__.Crud.salvar")) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.cancel()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("__.Crud.voltar")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("pesquisaManipulacaoComponent", {
        ref: "pesquisaManipulacaoComponent",
        on: { onSelect: _vm.onReturnPesquisa },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }